import { ArcwarePixelStreaming } from "../../ArcwarePixelStreaming";
import { StopIcon } from "../StopIcon";
import { PlayIcon } from "../PlayIcon";

export class StopButton {
  private button: HTMLButtonElement;
  private stream: ArcwarePixelStreaming;
  private stopIcon: StopIcon;
  private playIcon: PlayIcon;
  private tooltipText: HTMLElement;
  private isStreaming: boolean = true; // Assuming streaming starts by default

  constructor(stream: ArcwarePixelStreaming) {
    this.stream = stream;
    this.button = this.createButton();
    this.stopIcon = new StopIcon();
    this.playIcon = new PlayIcon();
    this.tooltipText = this.createTooltipText();
    this.button.appendChild(this.tooltipText);
    this.button.appendChild(this.stopIcon.stopIcon);
    this.button.addEventListener("click", this.toggleStreaming.bind(this));
    stream.onStreamingStateChange(this.updateButtonState.bind(this));
  }

  private createButton(): HTMLButtonElement {
    const button = document.createElement("button");
    button?.setAttribute("id", "stopBtn");
    button?.setAttribute("type", "button");
    button?.classList?.add("UiTool");
    return button;
  }

  private createTooltipText(): HTMLElement {
    const tooltipText = document.createElement("span");
    tooltipText?.classList?.add("tooltiptext");
    tooltipText.innerHTML = "Disconnect";
    return tooltipText;
  }

  private toggleStreaming(): void {
    this.isStreaming = !this.isStreaming;
    this.updateButtonIcon();
    if (this.isStreaming) {
      this.stream.reconnect();
    } else {
      this.stream.disconnect();
    }
  }

  private updateButtonIcon(): void {
    // Determine which icon + tooltip should be currently displayed
    const currentIcon = this.isStreaming ? this.stopIcon.stopIcon : this.playIcon.playIcon;
    const currentTooltipText = this.isStreaming ? "Disconnect" : "Reconnect";

    // Update tooltip text
    this.tooltipText.innerHTML = currentTooltipText;
    // Remove the first child if it exists
    if (this.button.firstChild) {
      this.button.removeChild(this.button.children[1]);
    }
    // Append the new icon
    this.button.appendChild(currentIcon);
  }

  public get element(): HTMLButtonElement {
    return this.button;
  }

  private updateButtonState(isStreaming: boolean): void {
    this.isStreaming = isStreaming;
    this.updateButtonIcon();
  }
}
